module.exports = __webpack_public_path__ + "mobile/img/main_logo_kogene.97247c63.png";